import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { analytics } from './lib/analytics';
import './index.css';

// Initialize PostHog before rendering so the very first $pageview carries
// the right distinct_id (bootstrapped from ?ph_did if present).
analytics.init();
analytics.captureUtmsFromUrl();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
